import gql from 'graphql-tag';

const USER_PROFILE_UPDATE = gql`
  mutation USER_PROFILE_UPDATE($record: UpdateUserProfileInput!) {
    userProfileUpdate(record: $record) {
      recordId
      record {
        __typename
        _id
        profile {
          __typename
          firstName
          lastName
          avatar
          email
          nationality {
            code
            name
          }
          workPermit {
            id
            name
          }
        }
      }
    }
  }
`;

export { USER_PROFILE_UPDATE };
